import { QueryClientProvider } from '@tanstack/react-query'
import * as React from 'react'
import * as ReactDOM from 'react-dom'

import initI18n from '../i18n'
import '../css/tailwind.css'
import '../css/kendoUI.css'
import '../css/kendo-overrides.css'
import '../css/Common.css'
import '../css/DropdownMenu.css'
import {
  getTeamsContext,
  initializeTeamsRuntime,
} from './features/auth/utils/teamsRuntime'
import { isTeamsApp } from './constants'
import { queryClient } from './lib/queryClient'
import { configureUserTimeZone } from './utils/timeZone'

// 定义全局对象存储用户信息
let globalUserInfo: { email: string | null } = { email: null }

// 初始化 Teams SDK 和获取上下文信息
async function initializeTeams() {
  if (!isTeamsApp) return

  const result = await initializeTeamsRuntime()
  const context = result.context || getTeamsContext()

  if (context?.user?.userPrincipalName) {
    globalUserInfo.email = context.user.userPrincipalName
  } else if (result.inTeams) {
    console.error('用户信息获取失败: userPrincipalName 不存在')
  }
}

// 获取全局用户信息
function getUserInfo() {
  return globalUserInfo
}

// 渲染 React 组件的函数，确保在获取用户信息后再渲染
export const render = (
  Component: React.ComponentType,
  element: HTMLElement
) => {
  const waitForUserInfo = async () => {
    configureUserTimeZone()
    await initI18n() // 初始化 i18n 配置
    await initializeTeams() // 初始化 Teams

    // 渲染组件
    ReactDOM.render(
      React.createElement(
        QueryClientProvider,
        { client: queryClient },
        React.createElement(Component)
      ),
      element
    )
  }

  waitForUserInfo().catch(err => {
    console.error('初始化失败:', err)
  })
}

// 导出获取用户信息的方法
export { getUserInfo }

// 自动导出 MatteroomTab 相关模块
export * from './matteroomTab/MatteroomTab'
